import { useState } from "react";
import { supabase } from "./supabaseClient";
import { Form, ProgressBar, ListGroup, Button } from "react-bootstrap";

export default function MultiFileUpload({ onFilesUpdated }) {
  const [uploading, setUploading] = useState(false);
  const [files, setFiles] = useState([]); // Local state for the UI list

  async function handleUpload(e) {
    try {
      setUploading(true);
      const uploadedFiles = [...files];
      const newFiles = Array.from(e.target.files);

      for (const file of newFiles) {
        const fileExt = file.name.split('.').pop();
        const fileName = `${Math.random()}.${fileExt}`;
        const filePath = `${fileName}`;

        const { error: uploadError } = await supabase.storage
          .from('request-files')
          .upload(filePath, file);

        if (uploadError) throw uploadError;

        uploadedFiles.push({ name: file.name, path: filePath });
      }

      setFiles(uploadedFiles);
      onFilesUpdated(uploadedFiles); // Pass the whole array back to the main form
    } catch (error) {
      alert('Upload failed: ' + error.message);
    } finally {
      setUploading(false);
    }
  }

  return (
    <Form.Group className="mb-4">
      <Form.Label className="fw-bold">Attachments</Form.Label>
      <Form.Control 
        type="file" 
        multiple 
        onChange={handleUpload} 
        disabled={uploading} 
      />
      
      {uploading && <ProgressBar animated now={100} label="Uploading..." className="mt-2" />}

      <ListGroup className="mt-3">
        {files.map((f, idx) => (
          <ListGroup.Item key={idx} className="d-flex justify-content-between align-items-center small">
            <span>📄 {f.name}</span>
            <Button variant="link" className="text-danger p-0" onClick={() => {
               const filtered = files.filter((_, i) => i !== idx);
               setFiles(filtered);
               onFilesUpdated(filtered);
            }}>Remove</Button>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </Form.Group>
  );
}